import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Tilaa painotuotteita',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Tuotetiedot',
    [ProductOrderingSteps.ShippingInfo]: 'Toimitustiedot',
    payment: 'Maksu',
  },
  form: {
    title: 'Tilauksen tiedot',
    polygraphy_product_id: {
      label: 'Tuote',
      placeholder: 'Valitse tuote',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Esite - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Malli #1 🆕',
            [FlyerTemplate.Two]: 'Malli #2 🆕',
            [FlyerTemplate.Three]: 'Malli #3',
            [FlyerTemplate.Four]: 'Malli #4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Tarra - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Malli #1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Ovitarra - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Malli #1 🆕',
            [DoorStickerTemplate.Two]: 'Malli #2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Määrä',
      placeholder: 'Anna määrä',
    },
    service_level: {
      label: 'Palvelutaso',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Säästö',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Vakio',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Pika',
      },
    },
    shipping_company_name: {
      label: 'Yritys',
      placeholder: 'Anna yrityksen nimi',
    },
    shipping_salutation: {
      label: 'Puhuttelu',
      options: {
        mr: 'Herra',
        mrs: 'Rouva',
      },
    },
    shipping_first_name: {
      label: 'Etunimi',
      placeholder: 'Anna etunimi',
    },
    shipping_last_name: {
      label: 'Sukunimi',
      placeholder: 'Anna sukunimi',
    },
    shipping_country: {
      label: 'Maa',
      placeholder: 'Valitse maa',
    },
    shipping_state: {
      label: 'Osavaltio',
      placeholder: 'Valitse osavaltio',
    },
    shipping_city: {
      label: 'Kaupunki',
      placeholder: 'Anna kaupunki',
    },
    shipping_address: {
      label: 'Osoite',
      placeholder: 'Anna osoite',
    },
    shipping_zip_code: {
      label: 'Postinumero',
      placeholder: 'Anna postinumero',
    },
    shipping_phone_number: {
      label: 'Puhelinnumero',
      placeholder: 'Anna puhelinnumero',
    },
    create_invoice: {
      options: {
        true: 'Laskuta automaattisesti - Veloitus heti',
        false: 'Lähetä ilmaiseksi - Tämä on lahja',
      },
    },
  },
  table: {
    title: 'Aiemmat tilaukset',
    fields: {
      product: 'Tuote',
      quantity: 'Määrä',
      status: 'Tila',
      service_level: 'Palvelutaso',
      shipping: 'Toimitus',
      tracking_url: 'Seurantalinkki',
      created: 'Luotu',
      updated: 'Viimeisin päivitys',
    },
  },
  labels: {
    shipping_company: 'Yritys',
    shipping_salutation: 'Puhuttelu',
    shipping_first_name: 'Etunimi',
    shipping_last_name: 'Sukunimi',
    shipping_address: 'Osoite',
    shipping_zip_code: 'Postinumero',
    shipping_city: 'Kaupunki',
    shipping_phone_number: 'Puhelinnumero',
    show_shipping_details: 'Toimitustiedot',
    track_order: 'Seuraa tilausta',
    pending_from_provider: 'Odottaa toimittajaa',
  },
  modals: {
    confirmation: {
      title: 'Vahvista tilauksen tiedot',
    },
    free_order_confirmation: {
      title: 'Haluatko varmasti lähettää tuotteen {{product}} ilmaiseksi?',
      description: 'Olet valinnut, ettet veloita asiakasta tänään.\n Tuote lähetetään ilman maksua.',
      buttons: {
        confirm: 'Kyllä, lähetä ilmaiseksi',
      },
    },
  },
  buttons: {
    back_to_templates: 'Takaisin malleihin',
    preview: 'Esikatselu',
    next: 'Seuraava',
    order: 'Luo tilaus',
    confirm: 'Vahvista',
  },
  feedback: {
    shop_url_used: 'Tuote sisältää verkkokaupan URL-osoitteen (<url>{{url}}</url>). Onko tämä tarkoituksellista?',
    order_total_price: 'Valittujen tuotteiden kokonaishinta: <strong>{{amount}} NETTO</strong>',
  },
  toasts: {
    failed_to_create_order: 'Tilauksen luominen epäonnistui',
    order_got_created: 'Tilaus luotiin',
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
